






















































































import Button from '../../core/components/Button.vue';
import InputFile from '../../core/components/InputFile.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Combobox from '../../core/components/Combobox.vue';
import {
    EventBus,
    sortObjectByPropertyName,
    TypeEventBus,
} from '../../core/utils';
import { Component, Prop, Mixins, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { SuscriptionsList, uploadExcelBtnInfo } from '../../core/models';
import { ReportsServices } from '../api/ReportsServices';
import PreviousExcelsList from './PreviousExcelsList.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';

@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        InputFile,
        PreviousExcelsList,
        Combobox,
        InfoIcon
    }
})
export default class ModalUploadExcel extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: null}) suscriptionData: SuscriptionsList;
    modalTitle: string = "Cargar datos para el reporte: ";
    submitName: string = 'Guardar';
    errorMsg: string = '';
    updatingReport: boolean = false;
    pendingAction: boolean = false;
    fileSelected: any = [];
    fileContent: any = null;
    fileLoaded: boolean = false;
    uploadingExcel: boolean = false;
    companiesList: any = [];
    companySelected: any | null = null;
    companySelectedRV: boolean = false;

    get getTooltipByReport() {
        let templateId = this.suscriptionData['template']['template_id']
        let tooltips = uploadExcelBtnInfo;

        if(tooltips[templateId]){
            return tooltips[templateId]
        }

        return ''
    }

    clearFile() {
        this.fileSelected = [];
        this.fileContent = null;
        this.fileLoaded = false;
    }

    clearInputModel(){
        let inputFile: any = this.$refs.inputFileRef;
        if (inputFile) {
            inputFile.clearModel();
        }
    }

    updateSelectedCompany(value) {
        this.companySelected = value;
    }
    updateCompanySelectedRV(value) {
        this.companySelectedRV = value;
    }

    selectedFile(file) {
        this.fileSelected = file;
    }

    uploadFile() {
        //processing file
        let reader = new FileReader();
        let self = this;
        this.fileContent = null;
        this.fileLoaded = false;
        let file = this.fileSelected[0];
        let fileName = file.name
        this.fileContent = file;
        reader.readAsText(file);
        reader.onload = (e: any) => {
            self.fileLoaded = true;
        };

        //Send file to backend
        let formData = new FormData();
        formData.append('file', this.fileContent);
        formData.append('file_name', fileName);
        formData.append('template_name', this.suscriptionData['template']['template_name']);
        formData.append('company_id', this.companySelected['id']);
        this.submitExcel(formData);
    }

    submitExcel(formData: FormData) {
        this.uploadingExcel = true;
        ReportsServices.uploadExcelForReport(
            formData
        ).then((res) => {
            this.refreshExcelsList();
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'Error al cargar el Excel'
            })
        }).finally(() => {
            this.clearFile();
            this.clearInputModel();
            this.uploadingExcel = false;
        })
    }


    showUserPreferences(){
        EventBus.$emit(TypeEventBus.SHOW_USER_PREFERENCES);
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }



    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg, timeout){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: timeout
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg, timeout){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg,
            timeout: timeout
        });
    }

    get excelsListElement(): HTMLFormElement {
        return this.$refs.excelsListRef as HTMLFormElement;
    }


    refreshExcelsList() {
        
        this.excelsListElement.getExcelsList();
    }

  

    @Emit()
    closeModal() {
        
    }


    loadInfo(){
        this.addReportNameToTitle();
        this.setCompanies();
        this.preselectCompany();
    }

    setCompanies(){
        this.companiesList = this.$_getCompanies.sort(sortObjectByPropertyName('name'));
    }

    preselectCompany(){
        let companyId = this.$_getSelectedCompanyById as number;
        let indexCompany = this.companiesList.findIndex(company => Number(company['id']) == companyId);
        if(indexCompany !== -1){
            this.companySelected = this.companiesList[indexCompany];

        }
    }
    

    addReportNameToTitle(){
        this.modalTitle += `<b>${this.suscriptionData.template.template_description}</b>`
    }

    mounted() {
        this.$nextTick(() => {
            this.loadInfo();
        });
    }
}
